export default __webpack_public_path__ + "static/media/AC330-value _ OBJECTS, diamond, diamante ACTIVITIES, value, valor.dfcfec88.svg";